import Color from "color";

export function calculateDisabledColor(color) {
  let lightThreshold = 40;
  let c = Color(color);
  if (c.lightness() < lightThreshold) {
    c = c.lightness(lightThreshold);
  }
  return c.lighten(0.8).hex();
}